import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import GetAllFormFields from "../../../../components/_utils/formUtils";
import Webcam from "react-webcam";
import Autosuggest from 'react-autosuggest';

// import {FormUtils as GetAllFormFields, TableComp} from 'sz-react-utils'
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Drawer,
  Form,
  Icon,
  Input,
  InputNumber,
  Modal,
  notification,
  Row,
  Select,
  Steps,
  Table,
  Tabs,
  Tag,
  Tooltip,
  DatePicker,
} from "antd";
import _ from "lodash";
import AddBranch from "../../../../containers/Masters/branch/add/index";
import { hideLoader, showLoader } from "../../../../modules/actions";
import Request, { API_URL, LAPI_URL } from "../../../../request";
import { connect } from "react-redux";
import style from "./style.less";
import Quali from "../../../../components/qualification";
import moment from "moment";
import Moment from "moment/moment";
import { TableComp } from "sz-react-utils";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const { MonthPicker } = DatePicker
const Step = Steps.Step;
const TabPane = Tabs.TabPane;
// following variables needed for update country
let docLoaded = null;
let countryId = null;
let sourceOptions = ["Direct", "Sub Agent", "Employee Referral", "Lead Referral", "External Referral", "Loyality Program"];
const Option = Select.Option;

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user",
  imageSmoothing: false,
};
const typeofDegree = {
  Diploma: [
    { key: "Diploma Of Engineering", value: "Diploma Of Engineering" },
    { key: "Diploma Of Management", value: "Diploma Of Management" },
  ],
  "Bachelor Degree": [
    { key: "Bachelor of Agriculture", value: "Bachelor of Agriculture" },
    { key: "Bachelor of Arts", value: "Bachelor of Arts" },
    {
      key: "Bachelor of Ayurvedic Medicine & Surgery - BAMS",
      value: "Bachelor of Ayurvedic Medicine & Surgery - BAMS",
    },
    {
      key: "Bachelor of Business Administration",
      value: "Bachelor of Business Administration",
    },
    { key: "Bachelor of Commerce", value: "Bachelor of Commerce" },
    {
      key: "Bachelor of Computer Applications",
      value: "Bachelor of Computer Applications",
    },
    {
      key: "Bachelor of Computer Science",
      value: "Bachelor of Computer Science",
    },
    {
      key: "Bachelor of Dental Surgery - BDS",
      value: "Bachelor of Dental Surgery - BDS",
    },

    { key: "Bachelor of Design", value: "Bachelor of Design" },
    { key: "Bachelor of Education", value: "Bachelor of Education" },
    { key: "Bachelor of Engineering", value: "Bachelor of Engineering" },
    { key: "Bachelor of Fine Arts", value: "Bachelor of Fine Arts" },
    { key: "Bachelor of Home Science", value: "Bachelor of Home Science" },

    {
      key: "Bachelor of Homeopathic Medicine and Surgery - BHMS",
      value: "Bachelor of Homeopathic Medicine and Surgery - BHMS",
    },
    { key: "Bachelor of Laws", value: "Bachelor of Laws" },
    {
      key: "Bachelor of Mass Communications",
      value: "Bachelor of Mass Communications",
    },
    {
      key: "Bachelor of Medicine and Bachelor of Surgery (MBBS)",
      value: "Bachelor of Medicine and Bachelor of Surgery (MBBS)",
    },
    { key: "Bachelor of Nursing", value: "Bachelor of Nursing" },
    { key: "Bachelor of Pharmacy", value: "Bachelor of Pharmacy" },
    { key: "Bachelor of Physiotherapy", value: "Bachelor of Physiotherapy" },
    { key: "Bachelor of Science", value: "Bachelor of Science" },
    { key: "Bachelor of Social Work", value: "Bachelor of Social Work" },
    { key: "Bachelor of Technology", value: "Bachelor of Technology" },
    {
      key: "Bachelor of Veterinary Science & Animal Husbandry",
      value: "Bachelor of Veterinary Science & Animal Husbandry",
    },
    { key: "Doctor of Medicine", value: "Doctor of Medicine" },
    {
      key: "Doctor of Medicine in Homoeopathy",
      value: "Doctor of Medicine in Homoeopathy",
    },
    { key: "Doctor of Pharmacy", value: "Doctor of Pharmacy" },
    { key: "Doctorate of Medicine", value: "Doctorate of Medicine" },
    {
      key: "General Nursing & Midwifery (GNM)",
      value: "General Nursing & Midwifery (GNM)",
    },
    { key: "Bachelor of Journalism", value: "Bachelor of Journalism" },
    { key: "ITI", value: "ITI" },
    { key: "Other", value: "Other" },
  ],
  "Post Graduation": [
    { key: "Master of Agriculture", value: "Master of Agriculture" },
    { key: "Master of Arts", value: "Master of Arts" },
    {
      key: "Master of Ayurvedic Medicine & Surgery - BAMS",
      value: "Master of Ayurvedic Medicine & Surgery - BAMS",
    },
  ],
};

@Form.create()
class AddInquiry extends PureComponent {


  loadStates = async id => {
    Request.loadStates(id)
      .then(daa => {
        daa.result = daa.result.reduce((total, val) => {
          total.push({
            id: val._id,
            _id: val._id,
            display: val.stateName
          })
          return total
        }, [])

        this.setState({ statesData: daa.result })
      })
      .catch(err => {
      })
  }
  loadCitiesByState = async id => {
    Request.loadCities(id)
      .then(data => {
        data.result = data.result.reduce((total, val) => {
          total.push({
            id: val._id,
            _id: val.cityId,
            display: val.cityName
          })
          return total
        }, [])
        this.setState({ citiesData: data.result })
      })
      .catch(err => {
      })
  }

  loadDealingCountries = () => {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getDealingCountries({ ...params }).then((resp) => {
      let dealingPhoneCodes = [];
      let dealingCountryPhoneCodes = [];
      let dealingCountryFieldArr = [];
      resp.data = resp.data.reduce((temp, vv) => {
        dealingCountryFieldArr.push({ _id: vv._id, display: vv.countryName });
        if (vv.countryPhoneCode) {
          dealingCountryPhoneCodes[vv._id] = vv.countryPhoneCode;
          dealingPhoneCodes.push(vv.countryPhoneCode);
        }
        temp.push({ ...vv });
        return temp;
      }, []);
      this.setState({ dealingCountryArr: resp.data, dealingCountryFieldArr: dealingCountryFieldArr, dealingPhoneCodes: dealingPhoneCodes, dealingCountryPhoneCodes: dealingCountryPhoneCodes });
    })
  }

  loadCountries = () => {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth({ ...params })
      .then((resp) => {
        let countryFieldArr = [];
        let phoneCodes = [];
        let countryPhoneCodes = [];
        resp.data = resp.data.reduce((temp, vv) => {
          countryFieldArr.push({ _id: vv._id, display: vv.countryName });
          if (vv.countryPhoneCode) {
            countryPhoneCodes[vv._id] = vv.countryPhoneCode;
            phoneCodes.push(vv.countryPhoneCode);
          }
          temp.push({ ...vv });
          return temp;
        }, []);
        this.setState({ countryArr: resp.data, countryFieldArr: countryFieldArr, phoneCodes: phoneCodes, countryPhoneCodes: countryPhoneCodes });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  constructor(props) {
    super(props);
    this.state = {
      showSave: 1,
      showFiles: 0,
      refreshChild: false,
      locationSet: false,
      show: true,
      countryArr: [],
      modeArr: [],
      value: '',
      from: null,
      maritalArr: [],
      testTypeList: [],
      testTypeArray: [],
      genderArr: [],
      countryFieldArr: [],
      countryPhoneCodes: [],
      phoneCodes: [],
      allEmployees: [],
      allMembers: [],
      totalPreference: [],
      suggestions: [],
      telecallers: [],
      employeeReferral: false,
      leadReferral: false,
      statesData: [],

      citiesData: [],
      externalReferral: false,
      city: null,
      country: null,
      visible: false,
      showModal: false,
      duplicateMsg: null,
      applicantSufferMedicalCondition: false,
      applicantConvictedCriminalOffence: false,
      totalData1: [],
      nextYears: [],
      showParentField: false,
      current: 0,
      list: [],
      referenceList: [],
      allUsers: [],
      operationManagers: [],
      userId: "",
      totalData: [],
      mailToStudent: "Yes",
      smsToStudent: "Yes",
      withSMS: "With SMS",
      imageSrc: null,
      isAdmin: false,
      isStateHead: false,
      loyalityProgram: false,
      location: "",
      countryCode: '',
      applicantCitizenMoreCountrySwitch: false,
      ifWhatsAppNumberIsDifferentSwitch: false,
      ifApplicantHasEmail: true,
      applicantLivingStudyingAnyOtherCountrySwitch: false,
      applicantAppliedAnyTypeImmigrationCountryIdSwitch: false,
      applicantVisaRefusalCountryIdSwitch: false,
      haveEnglishTestScore: false,
      showOtpField: false,
      mobile: '',
      parentMobile: '',
      otpSendTo: '',
      sendOtpField: false,
      studentId: null,
      isOtpVerified: false,
      isTelecallerUser: false,
      speaking: 0,
      reading: 0,
      writing: 0,
      listening: 0,
      ieltsOverallScore: 0,
      gapTotal: "",
      localUser: {},
      haveBackgroundInformation: null,
      havePassport: null,
      sameAsPeramanentAddress: false,
      dealingCountryArr: [],
      dealingCountryFieldArr: [],
      dealingPhoneCodes: [],
      dealingCountryPhoneCodes: [],
      showReferFriend: false
    };
    this.table = React.createRef();
    this.loadCountries();
    this.loadDealingCountries()
  }

  calculateOverAll = () => {
    let totalSum = 0;
    let { listening, writing, reading, speaking, suggestions } = this.state;
    if (listening > 0) {
      totalSum += parseFloat(listening);
    }
    if (writing > 0) {
      totalSum += parseFloat(writing);
    }
    if (reading > 0) {
      totalSum += parseFloat(reading);
    }
    if (speaking > 0) {
      totalSum += parseFloat(speaking);
    }
    let ieltsOverallScore = 0;
    if (totalSum >= 11) {
      let data = 0;
      totalSum = Math.floor(totalSum);
      if (totalSum % 2 != 0) {
        data = totalSum + 1;
      } else {
        data = totalSum;
      }
      ieltsOverallScore = parseFloat(data / 4).toFixed(1);
    }
    this.setState({ ieltsOverallScore });
    this.props.form.setFieldsValue({ ieltsOverallScore });
  }


  removeReferenceStudent = (index) => {
    this.setState((prevState) => {
      const referenceList = [...prevState.referenceList]; // Create a shallow copy
      referenceList.splice(index, 1); // Remove the item at the specified index
      return { referenceList }; // Return the updated state
    });
  }

  loadAssociativePartners = (source) => {
    if (source == "Sub Agent") {
      return new Promise(async (resolve) => {
        this.setState({ isOtpVerified: true, showOtpField: false });
        let params = {
          status: true,
          branchAssociatePartner: "Associate Partner",
          sortField: "branchName",
          results: 1000,
          loginId: "Yes"
        };

        let data = await Request.loadSimpleBranch({ ...params });
        this.props.dispatch({
          type: "SET_ALL_CP",
          data: data.data,
        });

        this.setState({
          locationSet: true,
          location: source,
        });
      });
    } else {
      this.setState({
        locationSet: false,
        location: source,
      });
    }
  };


  loadCities = (countryId) => {
    return new Promise(async (resolve) => {
      let data = await Request.loadCitiesByCountry(countryId);
      this.setState({ cityArr: data.result });
    });
  };

  handleReferenceSubmit = () => {
    let { form } = this.props;
    let referenceFromValues = form.getFieldsValue(['referenceStudentName', 'referenceCountryCode', 'referenceMobile', 'referenceInterestedIn'])
    if (!referenceFromValues.referenceStudentName) {
      notification.error({
        message: 'Expect Reference Student Name!'
      })
      return
    }
    if (!referenceFromValues.referenceCountryCode) {
      notification.error({
        message: 'Expect Reference Country Code!'
      })
      return
    }
    if (!referenceFromValues.referenceMobile) {
      notification.error({
        message: 'Expect Reference Mobile Number!'
      })
      return
    }
    if (!referenceFromValues.referenceInterestedIn) {
      notification.error({
        message: 'Expect Reference Interested In!'
      })
      return
    }
    let referenceList = this.state.referenceList
    referenceList.push(referenceFromValues)
    this.setState({ referenceList, showReferFriend: false }, () => {
      this.props.form.setFieldsValue({
        referenceStudentName: null,
        referenceCountryCode: null,
        referenceMobile: null,
        referenceInterestedIn: null
      })
    });

  }

  handleSubmit = (e) => {
    const { dispatch, form } = this.props;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let qualification = this.state.list;
        let references = this.state.referenceList;
        qualification = _.map(qualification, (item) => {
          delete item.editable;
          item._id = Moment().unix();
          return item;
        });
        let values = _.clone(valData);
        if (this.state.mailToStudent) {
          values.mailToStudent = this.state.mailToStudent;
        }
        if (this.state.smsToStudent) {
          values.smsToStudent = this.state.smsToStudent;
        }
        values.selectInquiryType = 'Study Abroad'
        values.references = references
        values.profile = {
          listening: values.listening,
          reading: values.reading,
          writing: values.writing,
          speaking: values.speaking,
          newQualification: qualification,
          overAllScore: values.ieltsOverallScore,
          address: values.address,
          landline: values.landline,
          passportNumber: values.passport,
        };
        delete values.listening;
        delete values.reading;
        delete values.writing;
        delete values.speaking;
        delete values.qualification;
        delete values.address;
        delete values.landline;
        delete values.passport;

        values.totalPreference = this.state && this.state.totalPreference;
        values.reference = this.state.totalData;

        values.profile.jobDetails = [];

        _.each(this.state.totalData1, (item) => {
          let abc = {};
          abc.phone = item.phone;
          abc.from = item.from;
          abc.to = item.to;
          abc.jobTitle = item.jobTitle;
          abc.company = item.company;
          abc.contactPerson = item.contactPerson;
          values.profile.jobDetails.push(abc);
        });

        if (0 && countryId) {
          values = { ...values, _id: countryId };

          dispatch(showLoader());

          let x = await Request.updateBranch(values);

          dispatch(hideLoader());

          if (!x.error) {
            notification.success({
              message: "Success",
              description: x.msg,
            });
          } else {
            notification.error({
              message: "Error Saving",
              description: x.msg,
            });
          }
        } else {
          dispatch(showLoader());
          let data = [];
          _.each(values.totalPreference, (item) => {
            let abc = {};
            abc.country = item.country.countryName;
            abc.city =
              item.city && item.city.cityName != null ? item.city.cityName : "";
            abc.countryId = item.country._id;
            abc.cityId =
              item.city && item.city._id != null ? item.city._id : "";
            data.push(abc);
          });
          values.totalPreference = data;

          let refData = [];
          _.each(values.reference, (item) => {
            let abc = {};
            abc.country = item.country.countryName;
            abc.countryId = item.country._id;
            abc.name = item.name;
            abc.mobile = item.mobile;
            refData.push(abc);
          });
          values.reference = refData;
          values.withSMS = this.state.withSMS;

          if (this.state.gapTotal !== "") {
            values.gapTotal = this.state.gapTotal
          }

          let formData = new FormData();

          formData.append("values", JSON.stringify(values));
          if (this.state.imageSrc) {
            formData.append("profileImage", this.state.imageSrc);
          }

          dispatch(showLoader());
          let x = await Request.addInquiry(formData);
          dispatch(hideLoader());
          if (!x.error) {
            notification.success({
              message: `${x.msg} with id - ${x.id}`,
            });

            form.resetFields();
            this.setState({
              totalPreference: [],
              list: [],
              current: 0,
              locationSet: false,
              totalData: [],
              imageSrc: null,
              showWebCam: false,
            });
            if (!this.state.id) {
              this.props.form.setFieldsValue({
                selectInquiryType: "STUDENT",
                mode: "Telephone",
                gender: "Male",
                location: "Direct",
                accompaniedByParentGuardian: "No",
                // dateOfBirth: moment().add(-18, "year"),
                ifApplicantHasEmail: "Yes"
              });
            }
          } else {
            notification.error({
              message: "Error Saving",
              description: x.msg,
            });
          }
        }
      }
    });
  };


  getAllSource = async () => {
    let response = await Request.getSourceDetails({
      results: 1000,
      count: 1000,
      active: true
    })
    let sourceObject = [];
    response.data && response.data.map((source) => {
      sourceObject.push(source.sourceName)
    })
    this.setState({ modeArr: sourceObject })
  }

  getAllGenders = async () => {
    let response = await Request.getGenderDetails({
      results: 1000,
      count: 1000
    })
    let genderObject = [];
    response.data && response.data.map((gender) => {
      genderObject.push(gender.genderName)
    })
    this.setState({ genderArr: genderObject })
  }

  getAllMaritalStatus = async () => {
    let response = await Request.getMaritalStatusDetails({
      results: 1000,
      count: 1000
    })
    let maritalObject = [];
    response.data && response.data.map((marital) => {
      maritalObject.push(marital.maritalStatus)
    })
    this.setState({ maritalArr: maritalObject })
  }
  getAllTestTypes = async () => {
    let response = await Request.getAllTestTypes({
      results: 1000,
      count: 1000
    });
    if (response && response.data) {
      let testTypeList = [];
      let testTypeArray = [];
      response.data.map((testTypeData) => {
        testTypeList.push(testTypeData.testType)
        if (testTypeArray[testTypeData.testType] == undefined) {
          testTypeArray[testTypeData.testType] = {};
        }
        testTypeArray[testTypeData.testType] = testTypeData;
      })
      this.setState({
        testTypeList: testTypeList,
        testTypeArray: testTypeArray
      });
    }
  }


  calculateGap = async () => {
    let gapTotal = null;
    let totalGapInMonths = 0
    let totalGapInYears = 0
    let { list, totalData1 } = this.state;
    let currentDate = moment();
    if (list && list.length > 0 && !totalData1.length) {
      list.sort((left, right) => {
        return moment.utc(left.from, "MM-YYYY").diff(moment.utc(right.from, "MM-YYYY"))
      });
      let lastQualificationEndDate = moment(list[list.length - 1].to, "MM-YYYY").endOf('month');
      let checkDiffInMonths = currentDate.diff(lastQualificationEndDate, 'months') % 12;
      let checkDiffInYears = currentDate.diff(lastQualificationEndDate, 'years');
      totalGapInYears += checkDiffInYears
      totalGapInMonths += checkDiffInMonths
    } else if (totalData1 && totalData1.length) {
      let jobList = _.clone(totalData1)
      jobList.sort((left, right) => {
        return moment.utc(left.from, "MM-YYYY").diff(moment.utc(right.from, "MM-YYYY"))
      });
      let lastJobEndDate = moment(jobList[jobList.length - 1].to, "MM-YYYY").endOf('month');
      let checkDiffInMonths = currentDate.diff(lastJobEndDate, 'months') % 12;
      let checkDiffInYears = currentDate.diff(lastJobEndDate, 'years');
      totalGapInYears += checkDiffInYears
      totalGapInMonths += checkDiffInMonths
    }

    if (totalGapInMonths > 11) {
      let getYearFromMonths = moment.duration(totalGapInMonths, 'months').asYears()
      totalGapInYears = totalGapInYears + getYearFromMonths
      totalGapInMonths = totalGapInMonths % 12
    }
    gapTotal = totalGapInYears > 0 || totalGapInMonths > 0 ? `${totalGapInYears > 0 ? totalGapInYears : ""} ${totalGapInYears > 0 ? totalGapInYears > 1 ? "Years" : "Year" : ""} ${totalGapInMonths > 0 ? totalGapInMonths : ""} ${totalGapInMonths > 0 ? totalGapInMonths > 1 ? "Months" : "Month" : ""}` : "No Gap"
    this.setState({ gapTotal })
  }

  loadEmployees = async (params) => {
    let { localUser } = this.state;
    if (!params) {
      params = {}
    }
    params.sortField = 'dateOfJoining'
    params.sortOrder = 'ascend'
    params.active = true
    params.count = 1000000
    params.results = 100000
    params.userBranch = localUser && localUser.userBranch ? localUser.userBranch : null
    let data = await Request.loadDeskUser({ ...params })
    let allEmployees = []
    _.each(data.data, (employee) => {
      allEmployees.push({ id: employee._id, display: employee.name })
    })
    this.setState({ allEmployees })

    // this.setState({totalUser: data.total})
  }

  loadMembers = async (params) => {
    if (!params) {
      params = {}
    }
    let data = await Request.getProgramMembers(params);
    let allMembers = []
    _.each(data.data, (member) => {
      allMembers.push({ id: member._id, display: `${member.membershipCode}-${member.name}` })
    })
    this.setState({ allMembers })
  }

  onSuggestionsFetchRequested = async () => {
    const { dispatch, form } = this.props
    let response = await Request.handleSearchStudent({
      searchField: this.state.searchField,
      results: 300
    });
    let suggestions = [];
    if (response.data) {
      response.data.map((student) => {
        suggestions.push({
          id: student._id,
          text: student.id + ' - ' + student.studentName + ' - ' + moment(student.dateOfBirth).format('ll')
        })
      })
    }
    this.setState({
      suggestions
    });
  }
  onSuggestionsFetchRequested = async () => {
    const { dispatch, form } = this.props
    let response = await Request.handleSearchStudent({
      searchField: this.state.searchField,
      results: 300
    });
    let suggestions = [];
    if (response.data) {
      response.data.map((student) => {
        suggestions.push({
          studentId: student.id,
          id: student._id,
          text: student.id + ' - ' + student.studentName + ' - ' + moment(student.dateOfBirth).format(dateFormat)
        })
      })
    }
    this.setState({
      suggestions
    });
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  onSuggestionSelected = async (event, { suggestion }) => {
    this.props.form.setFieldsValue({ referralName: suggestion.text })
  }
  onChange = (e) => {
    this.setState({
      value: e.target.value,
      searchField: e.target.value
    });
  };

  getSuggestionValue = (suggestion) => {
    this.setState({ studentId: suggestion.studentId })
    return suggestion.studentId;
  }

  renderSuggestion = (suggestion) => {
    return <span>{suggestion.text}</span>;
  }


  getNextFiveYears = async () => {
    let years = []
    for (let i = 0; i <= 5; i++) {
      let year = new Date().getFullYear() + i
      years.push(year.toString())
    }
    this.setState({ nextYears: years })
  }

  deleteImage = async () => {
    this.setState({ imageSrc: null })
  }


  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };
  setRef = (webcam) => {
    this.webcam = webcam;
  };


  _renderFormPart = (
    current,
    getFieldDecorator,
    inputSchma,
    referAFriendSchema,
    firstTabExtra,
    addressInputSchema,
    permanentAddressInputSchema,
    currentAddressInputSchema,
    passportInputSchema,
    nationalityInputSchema,
    backgroundInfoInputSchema,
    emergencyContactInputSchema,
    telecallerSchema,
    inputSchema2,
    inputSchema3,
    qualColumns,
    list,
    refColumns,
    jobColumns,
    referFriendColumns
  ) => {
    let { value, suggestions } = this.state;
    value = (value != undefined && value != 0 ? value : '');
    const inputProps = {
      placeholder: 'Search Student by Name, DOB, Mobile, Email ID',
      value,
      onChange: this.onChange
    };
    return (
      <div>
        <div style={{ display: current === 0 ? "inherit" : "none" }}>
          <Row>
            <Row>
              <Col span={14}>
                <GetAllFormFields
                  apiurl={LAPI_URL}
                  inputSchema={inputSchma}
                  getFieldDecorator={getFieldDecorator}
                />
                {
                  this.state.leadReferral ?
                    <Autosuggest
                      suggestions={suggestions}
                      onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                      onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                      onSuggestionSelected={this.onSuggestionSelected}
                      getSuggestionValue={this.getSuggestionValue}
                      renderSuggestion={this.renderSuggestion}
                      inputProps={inputProps}
                      className="auto-complete-input"
                      style={{ display: 'flex !important', justifyContent: 'center !important' }}
                    />
                    : null
                }
              </Col>
              <Col span={10}>
                <div className={style.infoBox1}>
                  Guidelines:
                  <br />
                  <br />
                  1. Student Name, Student Email ID, Mobile and Phone number are
                  MANDATORY fields.
                  <br />
                  <br />
                  2. Student Email ID should be of the student only.
                  <br />
                  <br />
                  3. Passport should be validup-to 6 months from today.
                  <br />
                  <br />
                  4. Birthdate should be entered in dd/mm/yyyy format only OR just
                  use the Datepicker.
                </div>
                <div className={style.horizontalDiv} style={{ paddingTop: '20px' }}>

                  <GetAllFormFields
                    layout={"horizontal"}
                    apiurl={LAPI_URL}
                    formItemLayout={{
                      labelCol: { span: 8 },
                      wrapperCol: { span: 16 },
                    }}
                    inputSchema={firstTabExtra}
                    getFieldDecorator={getFieldDecorator}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <h3 style={{ paddingTop: '25px' }}>Permanent Address</h3>
                <GetAllFormFields
                  apiurl={LAPI_URL}
                  inputSchema={permanentAddressInputSchema}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
              <Col span={24}>
                <h3 style={{ paddingTop: '25px' }}>Current Address</h3>
                <GetAllFormFields
                  apiurl={LAPI_URL}
                  inputSchema={currentAddressInputSchema}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
              <Col span={24}>
                <h3 style={{ paddingTop: '25px' }}>Background Info</h3>
                <GetAllFormFields
                  apiurl={LAPI_URL}
                  inputSchema={backgroundInfoInputSchema}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <h3 style={{ paddingTop: '25px' }}>Nationality Information</h3>
                <GetAllFormFields
                  apiurl={LAPI_URL}
                  inputSchema={nationalityInputSchema}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
              {/* <Col span={24}>
                <h3 style={{paddingTop: '25px'}}>Background Info</h3>
                <GetAllFormFields
                  apiurl={API_URL}
                  inputSchema={backgroundInfoInputSchema}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col> */}
            </Row>
            <Row>
              <Col span={24}>
                <h3 style={{ paddingTop: '25px' }}>Emergency Contact</h3>
                <GetAllFormFields
                  apiurl={LAPI_URL}
                  inputSchema={emergencyContactInputSchema}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <h3 style={{ paddingTop: '25px' }}>Telecaller Info</h3>
                <GetAllFormFields
                  apiurl={LAPI_URL}
                  inputSchema={telecallerSchema}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
            </Row>
          </Row>
        </div>
        <div style={{ display: current === 1 ? "inherit" : "none" }}>
          <Row>
            <Col span={16}>
              <GetAllFormFields
                inputSchema={inputSchema2}
                getFieldDecorator={getFieldDecorator}
              />
            </Col>
            <Col span={8}>
              <div className={style.infoBox}>
                Guidelines:
                <br />
                <br />
                1. Student Name, Student Email ID, Mobile and Phone number are
                MANDATORY fields.
                <br />
                <br />
                2. Student Email ID should be of the student only.
                <br />
                <br />
                3. Passport should be validup-to 6 months from today.
                <br />
                <br />
                4. Birthdate should be entered in dd/mm/yyyy format only OR just
                use the Datepicker.
              </div>
            </Col>
          </Row>
        </div>

        <div style={{ display: current === 3 ? "inherit" : "none" }}>
          <Quali
            handleSubmit={(data) => {
              let x = [...this.state.list, ...data];
              x = _.uniqBy(x, "qualification");
              this.setState({ list: x }, () => {
                this.calculateGap()
              });
            }}
          />
          <Table
            size={"small"}
            pagination={{
              defaultPageSize: 10,
              showSizeChanger: false,
              showQuickJumper: false,
            }}
            bordered={true}
            columns={qualColumns}
            dataSource={list}
            scroll={{ x: 1800 }}
          />
          <div>
            {/* <Card title="Refer a friend">
              <div className={"referenceItem"}>
                <a onClick={() => this.setState({ showReferFriend: true })}>Click to add</a>
                <Modal
                  title="Reference Details"
                  visible={this.state.showReferFriend}
                  onCancel={() => this.setState({ showReferFriend: false })}
                  onOk={() => this.setState({ showReferFriend: false })}
                  footer={[<Button
                    type="primary"
                    onClick={() => this.handleReferenceSubmit()}
                    style={{ marginBottom: 10 }}
                    loading={this.props.loading}>
                    SAVE
                  </Button>]}
                >
                  <Form>
                    <GetAllFormFields apiurl={API_URL} inputSchema={referAFriendSchema} getFieldDecorator={getFieldDecorator} />

                  </Form>
                </Modal>
              </div>
              <Row style={{ marginTop: 40 }}>
                <Col span={24}>
                  <Table
                    bordered={true}
                    style={{width:'100%'}}
                    columns={referFriendColumns}
                    dataSource={this.state.referenceList}
                    pagination={false}
                  />
                </Col>
              </Row>
              <br />
              <div className={"referenceItem refer-friend-section"}>
                <div>
                  <Row>
                    <Col span={24}>Name </Col>
                    <Col span={24}>
                      <Input
                        value={this.state.name}
                        onChange={(ei) => {
                          this.setState({ name: ei.target.value });
                        }}
                      />
                    </Col>
                  </Row>
                </div>
                <div>
                  <Row>
                    <Col span={24}>Mobile No </Col>
                    <Col span={24}>
                      <InputNumber
                        value={this.state.mobile}
                        style={{ width: 200 }}
                        max="10"
                        min="10"
                        onChange={(ei) => {
                          this.setState({ mobile: ei });
                        }}
                      />
                    </Col>
                  </Row>
                </div>
                <div>
                  <Row>
                    <Col span={24}>Country </Col>
                    <Col span={24}>
                      <Select
                        placeholder="Select Country"
                        optionFilterProp="children"
                        showSearch={true}
                        value={
                          this.state.country1
                            ? this.state.country1._id
                            : undefined
                        }
                        onChange={(ei) => {
                          let singleCountry = _.find(
                            this.state.countryArr,
                            (item) => {
                              return item._id == ei;
                            }
                          );
                          this.setState({
                            country1: singleCountry,
                            city: null,
                          });
                        }}
                      >
                        {this.state.countryArr.map((val, index) => {
                          return (
                            <Option key={index} value={val._id}>
                              {val.countryName}
                            </Option>
                          );
                        })}
                      </Select>
                    </Col>
                  </Row>
                </div>
                <div>
                  <Button
                    style={{
                      marginBottom: "9px",
                      marginTop: "17px",
                      height: "30px",
                    }}
                    size={"small"}
                    type="primary"
                    onClick={() => {
                      if (!this.state.country1) {
                        return notification.error({
                          message: "Choose Country",
                        });
                      }

                      if (!this.state.name) {
                        return notification.error({
                          message: "Enter name",
                        });
                      }
                      if (!this.state.mobile) {
                        return notification.error({
                          message: "Enter mobile",
                        });
                      }

                      if (
                        (this.state.country1 && this.state.name,
                          this.state.mobile)
                      ) {
                        let tt = this.state.totalData;
                        tt.push({
                          country: this.state.country1,
                          name: this.state.name,
                          mobile: this.state.mobile,
                        });
                        this.setState(
                          {
                            totalData: tt,
                            country1: null,
                            name: null,
                            mobile: null,
                          },
                          () => { }
                        );
                      }
                    }}
                  >
                    ADD
                  </Button>
                </div>
              </div>

              <Row style={{ marginTop: 40, display: "none" }}>
                <Col span={24}>
                  <Table
                    bordered={true}
                    rowKey={(x) => x.mobile}
                    columns={refColumns}
                    dataSource={this.state.totalData || []}
                    pagination={false}
                  />
                </Col>

                <Col span={24} style={{ marginTop: 10 }}>
                  <h4>With SMS</h4>
                  <Select
                    allowClear
                    showSearch={true}
                    style={{ width: 200 }}
                    placeholder="With SMS"
                    defaultValue={this.state.withSMS}
                    onChange={(v) => {
                      this.setState({
                        withSMS: v,
                      });
                    }}
                  >
                    <Option value="With SMS">With SMS</Option>
                    <Option value="Without SMS">Without SMS</Option>
                  </Select>
                </Col>
              </Row>
            </Card> */}
          </div>
          <div style={{ marginTop: 10 }}>
            <Card title="Job Details">
              <div>
                <Row>
                  <Col span={8}>
                    <Input
                      placeholder={"Job Title"}
                      value={this.state.jobTitle}
                      onChange={(ei) => {
                        this.setState({ jobTitle: ei.target.value });
                      }}
                    />
                  </Col>
                  <Col span={8}>
                    <Input
                      placeholder={"Company"}
                      value={this.state.company}
                      onChange={(ei) => {
                        this.setState({ company: ei.target.value });
                      }}
                    />
                  </Col>
                  <Col span={8}>
                    <Input
                      placeholder={"Reference Contact"}
                      value={this.state.contactPerson}
                      onChange={(ei) => {
                        this.setState({ contactPerson: ei.target.value });
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>
                    <Input
                      placeholder={"Phone"}
                      value={this.state.phone}
                      onChange={(ei) => {
                        this.setState({ phone: ei.target.value });
                      }}
                    />
                  </Col>
                  <Col span={8}>
                    <MonthPicker
                      placeholder={"From"}
                      value={this.state.from}
                      style={{ width: "100%" }}
                      onChange={(v) => {
                        this.setState({ from: v })
                      }} />
                    {/* <Input
                      placeholder={"From"}
                      value={this.state.from}
                      onChange={(ei) => {
                        this.setState({ from: ei.target.value });
                      }}
                    /> */}
                  </Col>
                  <Col span={8}>
                    <MonthPicker
                      placeholder={"To"}
                      value={this.state.to}
                      style={{ width: "100%" }}
                      onChange={(v) => {
                        this.setState({ to: v })
                      }} />
                    {/* <Input
                      placeholder={"To"}
                      value={this.state.to}
                      onChange={(ei) => {
                        this.setState({ to: ei.target.value });
                      }}
                    /> */}
                  </Col>
                </Row>
                <div>
                  <Button
                    style={{
                      marginBottom: "9px",
                      marginTop: "17px",
                      height: "30px",
                    }}
                    size={"small"}
                    type="primary"
                    onClick={() => {
                      let {
                        jobTitle,
                        company,
                        contactPerson,
                        to,
                        from,
                        phone,
                      } = this.state;


                      if (!jobTitle) {
                        return notification.error({
                          message: "Enter Job Title",
                        });
                      }

                      if (!company) {
                        return notification.error({
                          message: "Enter company",
                        });
                      }
                      if (!contactPerson) {
                        return notification.error({
                          message: "Enter contact person",
                        });
                      }
                      if (!phone) {
                        return notification.error({
                          message: "Enter phone no",
                        });
                      }
                      if (!from) {
                        return notification.error({
                          message: "Enter from",
                        });
                      }
                      if (!to) {
                        return notification.error({
                          message: "Enter to",
                        });
                      }

                      if (
                        jobTitle &&
                        company &&
                        contactPerson &&
                        to &&
                        from &&
                        phone
                      ) {
                        let tt = this.state.totalData1;
                        tt.push({
                          to: moment(this.state.to).format('MM-YYYY'),
                          from: moment(this.state.from).format('MM-YYYY'),
                          phone,
                          jobTitle,
                          company,
                          contactPerson,
                        });
                        this.setState(
                          {
                            totalData1: tt,
                            contactPerson: null,
                            company: null,
                            jobTitle: null,
                            phone: null,
                            from: null,
                            to: null,
                          },
                          () => {
                            this.calculateGap()
                          }
                        );
                      }
                    }}
                  >
                    Add Employment
                  </Button>
                </div>
              </div>

              <Row style={{ marginTop: 40 }}>
                <Col span={24}>
                  <Table
                    bordered={true}
                    rowKey={(x) => x.phone}
                    columns={jobColumns}
                    dataSource={this.state.totalData1 || []}
                    pagination={false}
                  />
                </Col>
              </Row>
            </Card>
            <Card title={"Education / Experience Gap"} bordered={true} style={{ marginTop: 10 }}>
              <p>{this.state.gapTotal}</p>
            </Card>
          </div>
        </div>
        <div style={{ display: current === 4 ? "inherit" : "none" }}>
        </div>
      </div>
    );
  };

  async componentDidMount() {
    await this.getAllSource()
    await this.getAllGenders()
    await this.getAllMaritalStatus();
    await this.getNextFiveYears()
    await this.getAllTestTypes();
    let localUser = JSON.parse(localStorage.getItem("user"));

    let { data: allUsers } = await Request.loadUser({
      results: 10000,
      isCounsellor: true,
      userBranch: localUser ? localUser.userBranch : null,
    });


    let { data: operationManagers } = await Request.loadUser({
      results: 10000,
      isOperationManager: true,
      active: true,
      userBranch: localUser ? localUser.userBranch : null,
    });


    this.setState({ allUsers, operationManagers, localUser });

    let { data: allTelecallers } = await Request.loadUser({
      results: 10000,
      isTelecaller: true,
      active: true,
      userBranch: localUser ? localUser.userBranch : null,
    });
    this.setState({ telecallers: allTelecallers })
    let found = _.find(allUsers, (user) => {
      return user.userBranch._id == localUser.userBranch;
    });
    if (found) {

      if (found.userBranch.branchName == "Karnal") {
        this.setState({
          isAdmin: true,
          isStateHead: found.userBranch.isStateHead
            ? found.userBranch.isStateHead
            : false,
        });
      } else {
        this.setState({
          isAdmin: false,
          isStateHead: found.userBranch.isStateHead
            ? found.userBranch.isStateHead
            : false,
        });
      }
    }


    if (!this.state.id) {
      setTimeout(() => {
        this.props.form.setFieldsValue({
          selectInquiryType: "Study Abroad",
          mode: "Choose Option",
          gender: "Choose Option",
          maritalStatus: "Choose Option",
          location: "Direct",
          accompaniedByParentGuardian: "No",
          ifApplicantHasEmail: "Yes",
          // dateOfBirth: moment().add(-18, "year"),
        });
      }, 1000);
    }

    if (localUser && localUser.isTelecaller) {
      this.setState({ isTelecallerUser: true });
      this.props.form.setFieldsValue({
        telecallerId: localUser._id
      });
    }
  }

  onSave = (index) => {
    const { form } = this.props;
    let x = form.getFieldsValue([
      "qualification",
      "percentage",
      "maths",
      "english",
      "stream",
      "major",
      "passingYear",
      "backlogs",
      "degreeType",
    ]);
    let editedData = [...this.state.list];
    editedData[index] = { ...x };
    this.setState({ list: editedData }, () => {
    });
  };

  next() {
    const { form } = this.props;
    const current = this.state.current + 1;
    let validationFields = [];
    if (current == 1) {
      validationFields = [
        "selectInquiryType",
        "studentName",
        "dateOfBirth",
        "gender",
        "mobile",
        "emailId"
      ];
      if (this.state.showParentField == true) {
        validationFields.push("parentGuardianName");
      }
      if (this.state.showOtpField == true) {
        validationFields.push("otp");
      }
      if (this.state.isOtpVerified == false) {
        return notification.error({
          message:
            "Mobile number is not verified, Please verify.",
        });
      }
    }
    if (current == 2) {
      validationFields = ["testType", "enqType", "counsellorId"];
    }
    if (current == 3) {
      if (this.state.totalPreference && !this.state.totalPreference.length) {
        return notification.error({
          message:
            "Add at least one where student may be interested or multiple universities you can add one by one",
        });
      }
    }
    form.validateFieldsAndScroll(validationFields, async (err, valData) => {
      if (!err) {
        this.setState({ current });
        // if ((this.state.sourceLocation != "Associate Partner" || this.state.sourceLocation != "Sub Agent") && current == 1) {
        //   let { error, msg } = await Request.checkDuplicateLead(valData);

        //   if (error) {
        //     this.setState({ showModal: true, duplicateMsg: msg });
        //   } else {
        //     this.setState({ current });
        //   }
        // } else {
        //   this.setState({ current });
        // }
      }
    });
  }

  sendOTPOnMobile = async (e) => {
    if (this.state.sourceLocation == 'Associate Partner' || this.state.sourceLocation == "Sub Agent") {
      this.setState({ isOtpVerified: true, showOtpField: false });
      return false;
    }
    let mobile = e.target.value;
    if (mobile) {
      const response = await Request.sendOTPOnMobile({ mobile });
      if (response && response.OtpSent == true) {
        this.setState({ showOtpField: true, mobile });
        return notification.success({
          message: "Welcome Code Sent.",
        });
      } else {
        return notification.warning({
          message: response.msg,
        });
      }
    }
  }

  verifyOTP = async (e) => {
    const response = await Request.verifyOTP({ mobile: this.state.mobile, otpValue: e.target.value });
    if (response && response.OtpVerified == true) {
      this.setState({ isOtpVerified: true, showOtpField: false });
      return notification.success({
        message: "Otp verified.",
      });
    } else {
      return notification.error({
        message: response.message,
      });
    }
  }

  checkNumberValues = async (e) => {
    let { form: { getFieldValue } } = this.props;
    let mobile = getFieldValue('mobile')
    if (mobile && e.target.value) {
      this.setState({ mobile: mobile, parentMobile: e.target.value, sendOtpField: true })
    }
  }

  checkSendOtp = async (value) => {
    if (this.state.sourceLocation == 'Associate Partner' || this.state.sourceLocation == "Sub Agent") {
      this.setState({ isOtpVerified: true, showOtpField: false });
      return false;
    }
    let mobile = null;
    if (value === "Student Number") {
      mobile = this.state.mobile
    } else if (value === "Parent Number") {
      mobile = this.state.parentMobile
    }
    if (mobile) {
      const response = await Request.sendOTPOnMobile({ mobile });
      if (response && response.OtpSent == true) {
        this.setState({ showOtpField: true, mobile });
        return notification.success({
          message: "Welcome Code Sent.",
        });
      } else {
        return notification.warning({
          message: response.msg,
        });
      }
    }
  }

  capture = () => {
    const imageSrc = this.webcam.getScreenshot();
    this.setState({
      imageSrc: imageSrc,
    });
  };

  prev() {
    const current = this.state.current - 1;
    this.setState({ current });
  }

  render() {
    let {
      userData,
      showOptions,
      isAdmin,
      isStateHead,
      showModal,
      duplicateMsg,
      applicantCitizenMoreCountrySwitch,
      ifWhatsAppNumberIsDifferentSwitch,
      applicantLivingStudyingAnyOtherCountrySwitch,
      applicantAppliedAnyTypeImmigrationCountryIdSwitch,
      applicantVisaRefusalCountryIdSwitch,
      phoneCodes,
      countryPhoneCodes,
      testTypeList,
      allEmployees,
      leadReferral,
      externalReferral,
      testTypeArray,
      loyalityProgram,
      employeeReferral,
      allMembers,
      dealingCountryArr,
      dealingCountryFieldArr,
      dealingPhoneCodes,
      dealingCountryPhoneCodes,
      testTypeScore = []
    } = this.state;
    const { dispatch } = this.props;

    const inputSchema2 = {
      fields: [
        {
          label: "Year Planning To Go",
          key: "whichYearPlanningToGo",
          prefixComp: <h3>Study Abroad Information</h3>,
          type: 'select',
          options: this.state.nextYears,
          onChange: v => {
            this.props.form.setFieldsValue({ whichYearPlanningToGo: v })
          }
        },
        {
          label: 'Do you have an English test score?',
          key: 'haveEnglishTestScore',
          type: 'select',
          options: ["Yes", "Preparing", "Will Plan Soon"],
          onChange: v => {
            if (v === "Yes") {
              this.setState({ haveEnglishTestScore: true });
            } else {
              this.setState({ haveEnglishTestScore: false });
            }
            // this.setState({haveEnglishTestScore: v});
            this.props.form.setFieldsValue({
              haveEnglishTestScore: v
            })
          }
        },
        {
          label: "Select Test Type",
          key: "testType",
          type: "select",
          showSearch: true,
          options: testTypeList,
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            let testTypeObject = testTypeArray[v] != undefined ? testTypeArray[v] : {};
            let testTypeScore = [];
            if (testTypeObject.endNumber) {
              for (let index = testTypeObject.startNumber; index <= testTypeObject.endNumber; index += testTypeObject.numberStep) {
                testTypeScore.push(index + '');
              }
            }
            this.setState({ testType: v, testTypeScore });
            this.props.form.setFieldsValue({ testType: v });
          },
        },
        {
          label: "Speaking Score",
          key: "speaking",
          type: "select",
          showSearch: true,
          options: testTypeScore,
          disabled: !this.state.testType,
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            this.setState({ speaking: v }, () => {
              // this.calculateOverAll();
            });
            this.props.form.setFieldsValue({ speaking: v });
          },
        },
        {
          label: "Listening Score",
          key: "listening",
          type: "select",
          options: testTypeScore,
          disabled: !this.state.testType,
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            this.setState({ listening: v }, () => {
              // this.calculateOverAll();
            });
            this.props.form.setFieldsValue({ listening: v });
          },
        },
        {
          label: "Writing Score",
          key: "writing",
          type: "select",
          options: testTypeScore,
          disabled: !this.state.testType,
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            this.setState({ writing: v }, () => {
              // this.calculateOverAll();
            });
            this.props.form.setFieldsValue({ writing: v });
          },
        },
        {
          label: "Reading Score",
          key: "reading",
          type: "select",
          options: testTypeScore,
          disabled: !this.state.testType,
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            this.setState({ reading: v }, () => {
              // this.calculateOverAll();
            });
            this.props.form.setFieldsValue({ reading: v });
          },
        },
        {
          label: "Overall Score",
          key: "ieltsOverallScore",
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            this.props.form.setFieldsValue({ ieltsOverallScore: v });
          },
        },
        // {
        //   label: "Send lead to IELTS center",
        //   key: "leadToIeltsCenter",
        //   type: "select",
        //   options: ["No", "Yes"],
        //   onChange: (v) => {
        //     this.props.form.setFieldsValue({ leadToIeltsCenter: v });
        //   },
        // },
        /* {
                   label: 'Send Welcome SMS to student',
                   key: 'smsToStudent',
                   type: 'select',
                   options: ['No', 'Yes'],
                   customDirectives: {initialValue: this.state.smsToStudent},
                   onChange: v => {
                     this.props.form.setFieldsValue({smsToStudent: v})
                   }
                 },
                 {
                   label: 'Send Welcome E-Mail to student',
                   key: 'mailToStudent',
                   type: 'select',
                   customDirectives: {initialValue: this.state.mailToStudent},
                   options: ['No', 'Yes'],
                   onChange: v => {
                     this.props.form.setFieldsValue({mailToStudent: v})
                   }
                 },*/
        {
          label: "Study Level",
          key: "enqType",
          type: "select",
          required: true,
          options: ["Under Graduate", "Post Graduate", "Schooling"],
          onChange: (v) => {
            this.props.form.setFieldsValue({ enqType: v });
          },
        },
        // {
        //   label: "Counsellor",
        //   key: "counsellorId",
        //   type: "select",
        //   showSearch: true,
        //   required: true,
        //   allowClear: true,
        //   keyAccessor: (x) => x._id,
        //   valueAccessor: (x) => x.name,
        //   disabled: false,
        //   options: this.state.allUsers ? this.state.allUsers : {},
        //   onChange: (v) => {
        //     this.props.form.setFieldsValue({ counsellorId: v });
        //   },
        // },
        {
          label: "Operation Manager",
          key: "operationManagerId",
          type: "select",
          showSearch: true,
          required: true,
          allowClear: true,
          keyAccessor: (x) => x._id,
          valueAccessor: (x) => x.name,
          disabled: false,
          options: this.state.operationManagers ? this.state.operationManagers : {},
          onChange: (v) => {
            this.props.form.setFieldsValue({ operationManagerId: v });
          },
        },
      ],
    };
    const referAFriendSchema = {
      fields: [
        {
          label: "Full Name",
          key: "referenceStudentName",
          prefixComp: <h3 style={{ margin: '10px 2px' }}>Basic information as per passport </h3>,
        },
        {
          label: 'Country Code',
          key: 'referenceCountryCode',
          type: 'select',
          options: dealingPhoneCodes,
          onChange: v => {
            this.props.form.setFieldsValue({ referenceCountryCode: v })
          }
        },
        {
          label: 'Mobile Number',
          key: 'referenceMobile',
        },
        {
          label: 'Interested In',
          key: 'referenceInterestedIn',
          type: 'select',
          options: [{ id: 'STUDENT', display: 'Study Abroad' }, { id: 'IELTS', display: 'IELTS/PTE' }, { id: 'VISITOR', display: 'Visitor Visa' }],
          onChange: v => {
            this.props.form.setFieldsValue({ referenceInterestedIn: v })
          }
        }
      ]
    }
    const inputSchma = {
      fields: [
        // {
        //   label: "Select Inquiry Type:",
        //   key: "selectInquiryType",
        //   required: true,
        //   showSearch: true,
        //   type: "select",
        //   options: ["STUDENT"],
        //   onChange: (v) => {
        //     this.props.form.setFieldsValue({
        //       selectInquiryType: v,
        //     });
        //   },
        // },
        {
          label: "Upload Image",
          prefixComp: (
            <div className={style.webCamBtn} >
              <div className={style.webCamInner} style={{ minWidth: 'fit-content' }}>
                <div style={{ margin: '10px 10px 10px 30px', textAlign: 'center', width: 'fit-content' }}>
                  {" "}
                  or &nbsp;
                </div>

                <Button onClick={() => this.setState({ showWebCam: true })} >
                  Capture Image
                </Button>
                {this.state.imageSrc ? (
                  <div style={{ display: "flex" }}>
                    <img src={this.state.imageSrc} className={style.smallImg} />
                    <p className={style.deleteImg} onClick={this.deleteImage}>{<Icon type="delete" />}</p>
                  </div>
                ) : null}
              </div>
            </div>
          ),
          key: "profilePic",
          type: "file",
          limit: 1,
          defaultFileList: [],
        },
        {
          label: "Full Name as per passport ",
          key: "studentName",
          prefixComp: <h3 style={{ margin: '10px 2px' }}>Basic information as per passport </h3>,
          required: true,
        },
        {
          label: "Date Of Birth",
          key: "dateOfBirth",
          type: "date",
          required: true,
        },
        {
          label: "Gender",
          key: "gender",
          required: true,
          type: "select",
          defaultValue: "nfjw",
          options: this.state.genderArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              gender: v,
            });
          },
        },
        {
          label: "Marital Status",
          key: "maritalStatus",
          required: true,
          type: "select",
          defaultValue: "nfjw",
          options: this.state.maritalArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              maritalStatus: v,
            });
          },
        },
        {
          label: "How you come to know about us",
          key: "mode",
          type: "select",
          showSearch: true,
          required: true,
          options: this.state.modeArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({ mode: v });
          },
        },
        {
          label: 'How do you want us to contact?',
          key: 'howToContact',
          type: 'select',
          showSearch: true,
          options: ["Direct Mobile Call", "Direct Whatsapp Call", "Only Whatsapp Message", "Only Email"],
          onChange: v => {
            this.props.form.setFieldsValue({ howToContact: v });
          }
        },
        {
          label: 'Preferred time to contact you?',
          key: 'contactPreferredTime',
          type: 'select',
          showSearch: true,
          options: ["Anytime", "10AM to 12PM", "12PM to 2PM", "2PM to 4PM", "4PM to 6PM", "After 6PM"],
          onChange: v => {
            this.props.form.setFieldsValue({ contactPreferredTime: v });
          }
        },
        {
          key: "accompaniedByParentGuardian",
          label: "Accompanied by Parent/Guardian",
          required: true,
          type: "select",
          options: ["No", "Yes"],
          defaultValue: "nfjw",
          showSearch: true,
          onChange: (v) => {
            this.setState({ showParentField: (v == 'Yes' ? true : false) })
            this.props.form.setFieldsValue({
              accompaniedByParentGuardian: v,
            });
          },
        },
        {
          label: "Parent/Guardian Name",
          key: "parentGuardianName",
          required: (this.state.showParentField === true),
          hidden: (this.state.showParentField === false)
        },
        {
          label: "Reference",
          key: "location",
          type: "select",
          disabled: !(isAdmin || isStateHead),
          options: sourceOptions,
          onChange: (v) => {
            this.setState({ sourceLocation: v });
            this.props.form.setFieldsValue({ location: v });
            this.loadAssociativePartners(v);
            if (v === "Employee Referral") {
              this.setState({ employeeReferral: true, leadReferral: false, externalReferral: false, loyalityProgram: false })
              this.loadEmployees()
            } else if (v === "Lead Referral") {
              this.setState({ leadReferral: true, employeeReferral: false, externalReferral: false, loyalityProgram: false })
              this.props.form.setFieldsValue({ employeeId: '' })
            } else if (v === "External Referral") {
              this.setState({ externalReferral: true, leadReferral: false, employeeReferral: false, loyalityProgram: false })
              this.props.form.setFieldsValue({ employeeId: '' })
            } else if (v === "Loyality Program") {
              this.setState({ loyalityProgram: true, externalReferral: false, leadReferral: false, employeeReferral: false })
              this.loadMembers()
            } else {
              this.setState({ externalReferral: false, leadReferral: false, employeeReferral: false, loyalityProgram: false })
            }
          },
        },
        {
          label: "Users",
          key: "associativePartnerId",
          type: "select",
          showSearch: true,
          hidden: !this.state.locationSet,
          keyAccessor: (x) => x._id,
          valueAccessor: (x) =>
            `${x.branchName} ${x.branchHeadPhone ? "(" + x.branchHeadPhone + ")" : ""
            }`,
          customProps: {
            style: {
              width: "calc(100% - 40px)",
            },
          },
          rightComp: (
            <Button
              style={{ marginLeft: "3px" }}
              type="primary"
              onClick={() => {
                this.showDrawer();
              }}
            >
              {<Icon type="plus" />}
            </Button>
          ),
          options: this.props.allChannelPartners,
          onChange: (user) => {
            this.setState({ associativePartnerId: user });

            this.props.form.setFieldsValue({ associativePartnerId: user });
          },
        },
        {
          label: 'Employee Name',
          key: 'employeeId',
          type: 'select',
          hidden: (this.state.sourceLocation == "Employee Referral" ? false : true),
          required: (this.state.sourceLocation == "Employee Referral" ? true : false),
          options: allEmployees,
          onChange: v => {
            this.props.form.setFieldsValue({ employeeId: v })
          }
        },
        {
          label: 'Referral Name',
          key: 'referralName',
          type: 'text',
          disabled: (this.state.sourceLocation == "Lead Referral" ? true : false),
          hidden: (this.state.sourceLocation == "Lead Referral" || this.state.sourceLocation == "External Referral" ? false : true),
          required: (this.state.sourceLocation == "Lead Referral" || this.state.sourceLocation == "External Referral" ? true : false)
        },
        {
          label: 'Member Name',
          key: 'membershipDetail',
          type: "select",
          options: allMembers,
          hidden: (loyalityProgram ? false : true),
          required: (loyalityProgram ? true : false),
          onChange: v => {
            this.props.form.setFieldsValue({ membershipDetail: v })
          }
        }
      ],
    };
    const firstTabExtra = {
      fields: [
        {
          label: "Country",
          key: "addressCountryId",
          type: "select",
          required: true,
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.dealingCountryFieldArr,
          onChange: (v) => {
            if (dealingCountryPhoneCodes) {
              let phoneCodeValue = (dealingCountryPhoneCodes[v] != undefined ? dealingCountryPhoneCodes[v] : '');
              this.props.form.setFieldsValue({ countryCode: phoneCodeValue });
            }
            this.props.form.setFieldsValue({
              addressCountryId: v,
            });
          },
        },
        {
          label: "Country Code",
          key: "countryCode",
          type: "select",
          required: true,
          disabled: true,
          showSearch: true,
          options: dealingPhoneCodes,
          onChange: (v) => {
            this.props.form.setFieldsValue({ countryCode: v });
          },
        },
        {
          label: "Mobile Number",
          key: "mobile",
          type: "number",
          required: true,
          style: { width: 307 },
          onBlur: v => {
            if (v.target.value.length < 10) {
              notification.error({
                message: "Mobile number must be at least 10 digits long."
              })
            }
          },
          // rightComp: (
          //   <div>
          //     {
          //       this.state.showOtpField ?
          //         <Button
          //           style={{ marginLeft: "3px" }}
          //           type="primary"
          //           onClick={() => {
          //             this.setState({
          //               showOtpField: false,
          //               isOtpVerified: true
          //             })
          //           }}
          //         >
          //           Skip
          //         </Button>
          //       :null
          //     }
          //   </div>
          // ),
          parser: (value) => value.substring(0, 10)
        },
        {
          label: 'Parents Number',
          key: 'parentMobile',
          type: 'number',
          required: true,
          style: { width: 307 },
          onBlur: v => {
            if (v.target.value.length < 10) {
              notification.error({
                message: "Mobile number must be at least 10 digits long."
              })
            } else {
              this.checkNumberValues(v)
            }
          },
          parser: (value) => value.substring(0, 10),
        },
        {
          label: 'Welcome Code To',
          key: 'sendOtpTo',
          type: 'select',
          required: this.state.sendOtpField,
          hidden: !this.state.sendOtpField,
          options: ["Student Number", "Parent Number"],
          onChange: v => {
            this.props.form.setFieldsValue({ sendOtpTo: v })
            this.checkSendOtp(v)
          },
          rightComp: (
            <div>
              {
                this.state.showOtpField ?
                  <Button
                    style={{ marginLeft: "3px" }}
                    type="primary"
                    onClick={() => {
                      this.setState({
                        showOtpField: false,
                        isOtpVerified: true
                      })
                    }}
                  >
                    Skip
                  </Button>
                  : null
              }
            </div>
          ),
        },
        {
          label: "Enter Welcome Code",
          key: "otp",
          type: "number",
          onBlur: v => {
            this.verifyOTP(v);
          },
          required: this.state.showOtpField,
          hidden: this.state.showOtpField ? false : true,
          style: { width: 307 },
          parser: (value) => value.substring(0, 10)
        },
        {
          label: 'WhatsApp same as above?',
          key: 'ifWhatsAppNumberIsDifferentSwitch',
          defaultValue: false,
          type: 'switch',
          onChange: v => {
            this.setState({ ifWhatsAppNumberIsDifferentSwitch: v });
            this.props.form.setFieldsValue({
              ifWhatsAppNumberIsDifferentSwitch: v
            })
          }
        },
        {
          label: "Whatsapp Number",
          hidden: (this.state.ifWhatsAppNumberIsDifferentSwitch == true),
          required: (this.state.ifWhatsAppNumberIsDifferentSwitch == false),
          key: "watsupp",
          type: "number",
          parser: (value) => value.substring(0, 10),
          style: { width: 307 },
        },
        {
          label: 'If Applicant has Email',
          key: 'ifApplicantHasEmail',
          type: 'select',
          options: ["Yes", "No", "Asked But Not Given"],
          defaultValue: "Yes",
          onChange: v => {
            if (v === "Yes") {
              this.setState({ ifApplicantHasEmail: true });
            } else {
              this.setState({ ifApplicantHasEmail: false });
            }
            this.props.form.setFieldsValue({
              ifApplicantHasEmail: v
            })
          }
        },
        {
          label: "Email Id ",
          type: 'email',
          hidden: (this.state.ifApplicantHasEmail == false),
          required: (this.state.ifApplicantHasEmail == true),
          key: "emailId",
          required: true
        },
        {
          label: 'Passport No.',
          type: 'switch',
          key: 'havePassport',
          onChange: v => {
            this.props.form.setFieldsValue({ havePassport: v }, () => {
              this.setState({ havePassport: v })
            })
          }
        },
        {
          label: "Passport Number",
          key: "passport",
          type: "text",
          hidden: !this.state.havePassport,
          required: this.state.havePassport
        },
      ],
    };

    const permanentAddressInputSchema = {
      fields: [
        {
          label: 'Permanent Address',
          key: 'address',
          type: 'textArea',
          required: true,
        },
        {
          label: 'Country',
          key: 'permanentAddressCountry',
          type: 'select',
          options: this.state.dealingCountryFieldArr,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ permanentAddressCountry: v }, () => {
              this.loadStates(v);
            })
          }
        },
        {
          label: 'State',
          key: 'permanentAddressState',
          type: 'select',
          options: this.state.statesData,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ permanentAddressState: v }, () => {
              this.loadCitiesByState(v);
            })
          }
        },
        {
          label: 'City',
          key: 'permanentAddressCity',
          type: 'select',
          options: this.state.citiesData,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ permanentAddressCity: v })
          }
        }
      ]
    }
    const currentAddressInputSchema = {
      fields: [
        {
          label: 'Same as Permanent Address',
          key: 'sameAsPeramanentAddress',
          type: 'checkbox',
          onClick: v => {
            this.setState({ sameAsPeramanentAddress: v.target.checked })
          }
        },
        {
          label: 'Current Address',
          key: 'currentAddress',
          type: 'textArea',
          hidden: this.state.sameAsPeramanentAddress
        },
        {
          label: 'Country',
          key: 'currentAddressCountry',
          type: 'select',
          options: this.state.dealingCountryFieldArr,
          hidden: this.state.sameAsPeramanentAddress,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ currentAddressCountry: v }, () => {
              this.loadStates(v);
            })
          }
        },
        {
          label: 'State',
          key: 'currentAddressState',
          type: 'select',
          options: this.state.statesData,
          hidden: this.state.sameAsPeramanentAddress,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ currentAddressState: v }, () => {
              this.loadCitiesByState(v);
            })
          }
        },
        {
          label: 'City',
          key: 'currentAddressCity',
          type: 'select',
          options: this.state.citiesData,
          hidden: this.state.sameAsPeramanentAddress,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ currentAddressCity: v })
          }
        }
      ]
    }

    const addressInputSchema = {
      fields: [
        {
          label: "Permanent Address",
          key: "address",
          type: "textArea",
          required: true,
        },
        {
          label: "Current Address",
          key: "address2",
          type: "textArea",
        },
        {
          label: "State",
          key: "state",
          type: "text"
        },
        {
          label: "City",
          key: "city",
          type: "text"
        },
        {
          label: "Pincode",
          key: "pincode",
          type: "text"
        },
      ]
    };
    const passportInputSchema = {
      fields: [
        {
          label: "Passport",
          key: "passport",
          type: "text"
        },
        {
          label: "Issue Date",
          key: "issueDate",
          type: "date"
        },
        {
          label: "Expiry Date",
          key: "expiryDate",
          type: "date"
        },
        {
          label: "Issue Country",
          key: "issueCountryId",
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              issueCountryId: v,
            });
          },
        },
        {
          label: "Country Of Birth",
          key: "countryOfBirth",
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              countryOfBirth: v,
            });
          },
        },
        {
          label: "City of birth",
          key: "cityOfBirth",
          type: "text"
        },
      ]
    };
    const nationalityInputSchema = {
      fields: [
        {
          label: "Nationality",
          key: "nationality",
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              nationality: v,
            });
          },
        },
        {
          label: "Citizenship",
          key: "citizenship",
          type: "select",
          defaultValue: "nfjw",
          showSearch: true,
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              citizenship: v,
            });
          },
        },
        {
          label: 'Citizen of more than one country?',
          key: 'applicantCitizenMoreCountrySwitch',
          type: 'switch',
          onChange: v => {
            this.setState({ applicantCitizenMoreCountrySwitch: v });
            this.props.form.setFieldsValue({
              applicantCitizenMoreCountrySwitch: v
            })
          }
        },
        {
          label: "Select Country",
          key: "applicantCitizenMoreCountry",
          hidden: (this.state.applicantCitizenMoreCountrySwitch == false),
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              applicantCitizenMoreCountry: v,
            });
          },
        },
        {
          label: 'applicant living and studying in any other country?',
          key: 'applicantLivingStudyingAnyOtherCountrySwitch',
          type: 'switch',
          onChange: v => {
            this.setState({ applicantLivingStudyingAnyOtherCountrySwitch: v });
            this.props.form.setFieldsValue({
              applicantLivingStudyingAnyOtherCountrySwitch: v
            })
          }
        },
        {
          label: "Select Country",
          key: "applicantLivingStudyingAnyOtherCountry",
          hidden: (this.state.applicantLivingStudyingAnyOtherCountrySwitch == false),
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              applicantLivingStudyingAnyOtherCountry: v,
            });
          },
        },
      ]
    };
    const backgroundInfoInputSchema = {
      fields: [
        {
          label: 'Background Information?',
          key: 'haveBackgroundInformation',
          type: 'switch',
          onChange: v => {
            this.setState({ haveBackgroundInformation: v });
            this.props.form.setFieldsValue({ haveBackgroundInformation: v })
          }
        },
        // {
        //   label: 'Background Information?',
        //   key: 'haveBackgroundInformation',
        //   type: 'select',
        //   options: [{ id: "Yes", display: 'Yes' }, { id: "No", display: 'No' }],
        //   onChange: v => {
        //     this.props.form.setFieldsValue({ haveBackgroundInformation: v }, () => {
        //       this.setState({ haveBackgroundInformation: v === "Yes" ? true : false })
        //     })
        //   }
        // },
        {
          label: 'Have you ever applied for any type of immigration/PR?',
          key: 'applicantAppliedAnyTypeImmigrationCountryIdSwitch',
          type: 'switch',
          hidden: !this.state.haveBackgroundInformation,
          onChange: v => {
            this.setState({ applicantAppliedAnyTypeImmigrationCountryIdSwitch: v });
            this.props.form.setFieldsValue({
              applicantAppliedAnyTypeImmigrationCountryIdSwitch: v
            })
          }
        },
        {
          label: "Select Country",
          key: "applicantAppliedAnyTypeImmigrationCountryId",
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          hidden: (this.state.applicantAppliedAnyTypeImmigrationCountryIdSwitch == false),
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              applicantAppliedAnyTypeImmigrationCountryId: v,
            });
          },
        },
        {
          label: "Any Serious Medical Condition?",
          key: "applicantSufferMedicalCondition",
          hidden: !this.state.haveBackgroundInformation,
          type: 'select',
          options: ['Yes', 'No'],
          onChange: v => {
            this.props.form.setFieldsValue({ applicantSufferMedicalCondition: v }, () => {
              if (v === 'Yes') {
                this.setState({ applicantSufferMedicalCondition: true })
              } else {
                this.setState({ applicantSufferMedicalCondition: false })
              }
            })
          }
        },
        {
          label: "Explain Serious Medical Condition",
          key: 'applicantMedicalCondition',
          hidden: !this.state.haveBackgroundInformation,
          type: 'textArea',
          required: this.state.applicantSufferMedicalCondition,
          hidden: !this.state.applicantSufferMedicalCondition
        },
        {
          label: 'Have you been refused visa from any country?',
          key: 'applicantVisaRefusalCountryIdSwitch',
          hidden: !this.state.haveBackgroundInformation,
          type: 'switch',
          onChange: v => {
            this.setState({ applicantVisaRefusalCountryIdSwitch: v });
            this.props.form.setFieldsValue({
              applicantVisaRefusalCountryIdSwitch: v
            })
          }
        },
        {
          label: "Select Country",
          key: "applicantVisaRefusalCountryId",
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          hidden: (this.state.applicantVisaRefusalCountryIdSwitch == false),
          onChange: (v) => {
            this.props.form.setFieldsValue({
              applicantVisaRefusalCountryId: v,
            });
          },
        },
        {
          label: "Has applicant ever been convicted of a criminal offence?",
          key: "applicantConvictedCriminalOffence",
          hidden: !this.state.haveBackgroundInformation,
          type: "select",
          options: ['Yes', 'No'],
          onChange: v => {
            this.props.form.setFieldsValue({ applicantConvictedCriminalOffence: v }, () => {
              if (v === "Yes") {
                this.setState({ applicantConvictedCriminalOffence: true });
              } else {
                this.setState({ applicantConvictedCriminalOffence: false })
              }
            })
          }
        },
        {
          label: 'Explain Criminal Offence',
          key: 'applicantCriminalOffence',
          type: 'textArea',
          required: this.state.applicantConvictedCriminalOffence,
          hidden: !this.state.applicantConvictedCriminalOffence
        }
      ]
    };
    const emergencyContactInputSchema = {
      fields: [
        {
          label: "Name",
          key: "emergencyName",
          type: "text"
        },
        {
          label: 'Country Code',
          key: 'emergencyCountryCode',
          type: 'select',
          options: phoneCodes,
          onChange: v => {
            this.props.form.setFieldsValue({ emergencyCountryCode: v })
          }
        },
        {
          label: "Mobile No ",
          key: "landline",
          type: "number",
          style: { width: 307 },
        },
        {
          label: "Email",
          key: "emergencyEmail",
          type: "text"
        },
        {
          label: "Relation with Applicant",
          key: "emergencyRelationShip",
          type: "text"
        }
      ]
    }

    const telecallerSchema = {
      fields: [
        {
          label: "Select Telecaller",
          key: "telecallerId",
          type: "select",
          disabled: this.state.isTelecallerUser,
          keyAccessor: (x) => x._id,
          valueAccessor: (x) => x.name,
          showSearch: true,
          options: this.state.telecallers,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              telecallerId: v,
            });
          },
        }
      ]
    }

    const inputSchema3 = {
      fields: [
        {
          label: "Standard",
          key: "standard",
          required: true,
          style: { width: 100 },
          type: "select",
          options: ["STUDENT"],
          onChange: (v) => {
            this.props.form.setFieldsValue({
              selectInquiryType: v,
            });
          },
        },
        {
          label: "Degree Type",
          key: "degreeType",
          style: { width: 100 },

          required: true,
          type: "select",
          options: ["MASTER OF ARCHITECUTRE"],
          onChange: (v) => {
            this.props.form.setFieldsValue({
              selectInquiryType: v,
            });
          },
        },
        { label: "Year", key: "year", style: { width: 100 } },
        {
          label: "Stream",
          key: "stream",
          required: true,
          style: { width: 100 },
          type: "select",
          options: [],
          tags: true,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              stream: v,
            });
          },
        },
        { label: "Grade ", key: "grade", style: { width: 100 } },
        { label: "Maths ", key: "maths", style: { width: 100 } },
        { label: "English ", key: "english", style: { width: 100 } },
        { label: "Backlogs", key: "backlogs", style: { width: 100 } },
        {
          label: "Major Subjects",
          key: "major",
          style: { width: 100 },
          required: true,
          type: "select",
          options: [],
          tags: true,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              major: v,
            });
          },
        },
      ],
    };

    const { submitting } = this.props;
    const { current, list } = this.state;
    const {
      form: { getFieldDecorator, getFieldValue },
    } = this.props;

    const qualColumns = [
      {
        title: 'Country Of Study',
        key: 'studyCountry',
        dataIndex: 'studyCountry',
        render: (item, record) => {
          return (
            <>
              {
                record.editable ?
                  <Form.Item>
                    {getFieldDecorator("studyCountry", {
                      initialValue: record.studyCountry ? record.studyCountry : null,
                    })(<Input />)}
                  </Form.Item>

                  : item
              }
            </>
          )
        }
      },
      {
        title: "Qualification",
        key: "qualification",
        dataIndex: "qualification",
        searchTextName: "",
        filterRegex: true,
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("qualification", {
                    initialValue: record.qualification
                      ? record.qualification
                      : null,
                  })(
                    <Select
                      showSearch
                      style={{ width: "100%" }}
                      onChange={(qualification) => {
                        record.qualification = qualification;
                      }}
                    >
                      <Option value={"X"}>X</Option>
                      <Option value={"XII"}>XII</Option>
                      <Option value={"Diploma"}>Diploma</Option>
                      <Option value={"Bachelor Degree"}>Bachelor Degree</Option>
                      <Option value={"Post Graduation"}>Post Graduation</Option>
                    </Select>
                  )}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "From",
        key: "from",
        dataIndex: "from",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("from", {
                    initialValue: record.from
                      ? record.from
                      : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "To",
        key: "to",
        dataIndex: "to",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("to", {
                    initialValue: record.to
                      ? record.to
                      : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Passing Year",
        key: "passingYear",
        dataIndex: "passingYear",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("passingYear", {
                    initialValue: record.passingYear
                      ? record.passingYear
                      : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Qualification Status",
        key: "qualificationStatus",
        dataIndex: "qualificationStatus",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("qualificationStatus", {
                    initialValue: record.qualificationStatus
                      ? record.qualificationStatus
                      : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Grading System",
        key: "gradingSystem",
        dataIndex: "gradingSystem",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("gradingSystem", {
                    initialValue: record.gradingSystem
                      ? record.gradingSystem
                      : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Score",
        key: "score",
        dataIndex: "score",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("score", {
                    initialValue: record.score
                      ? record.score
                      : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Stream ",
        key: "stream",
        dataIndex: "stream",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("stream", {
                    initialValue: record.stream ? record.stream : null,
                  })(
                    <Select
                      showSearch={true}
                      style={{ width: "100%" }}
                      dropdownMatchSelectWidth={false}

                    >
                      <Option value={"MEDICAL"}>MEDICAL</Option>
                      <Option value={"NON-MEDICAL"}>NON-MEDICAL</Option>
                      <Option value={"COMMERCE"}>COMMERCE</Option>
                      <Option value={"ARTS"}>ARTS</Option>
                    </Select>
                  )}
                </Form.Item>
              ) : (
                item && Array.isArray(item) ? item.map((ii) => <Tag>{ii}</Tag>) : item
              )}
            </>
          );
        },
      },
      {
        title: 'Primary Language Of Instruction',
        key: 'primaryInstructionLanguage',
        dataIndex: 'primaryInstructionLanguage',
        render: (item, record) => {
          return (
            <>
              {
                record.editable ?
                  <Form.Item>
                    {getFieldDecorator("primaryInstructionLanguage", {
                      initialValue: record.primaryInstructionLanguage ? record.primaryInstructionLanguage : null,
                    })(<Input />)}
                  </Form.Item>

                  : item
              }
            </>
          )
        }
      },
      // {
      //   title: "Percentage ",
      //   key: "percentage",
      //   dataIndex: "percentage",
      //   render: (item, record) => {
      //     return (
      //       <>
      //         {record.editable ? (
      //           <Form.Item>
      //             {getFieldDecorator("percentage", {
      //               initialValue: record.percentage ? record.percentage : null,
      //             })(<InputNumber />)}
      //           </Form.Item>
      //         ) : (
      //           item
      //         )}
      //       </>
      //     );
      //   },
      // },
      {
        title: "Maths ",
        key: "maths",
        dataIndex: "maths",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("maths", {
                    initialValue: record.maths ? record.maths : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "English ",
        key: "english",
        dataIndex: "english",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("english", {
                    initialValue: record.english ? record.english : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Major Subjects",
        key: "major",
        dataIndex: "major",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("major", {
                    initialValue: record.major ? record.major : null,
                  })(
                    <Select
                      mode="tags"
                      style={{ width: "100%" }}
                      placeholder="Tags Mode"
                    />
                  )}
                </Form.Item>
              ) : (
                item && item.map((ii) => <Tag>{ii}</Tag>)
              )}
            </>
          );
        },
      },
      {
        title: "Backlogs ",
        key: "backlogs",
        dataIndex: "backlogs",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("backlogs", {
                    initialValue: record.backlogs ? record.backlogs : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "University",
        key: "university",
        dataIndex: "university",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("university", {
                    initialValue: record.university ? record.university : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Board",
        key: "board",
        dataIndex: "board",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("board", {
                    initialValue: record.board ? record.board : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Degree Type ",
        key: "degreeType",
        dataIndex: "degreeType",
        render: (item, record) => {
          let condition =
            record.qualification == "Diploma" ||
            record.qualification == "Bachelor Degree" ||
            record.qualification == "Post Graduation";
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("degreeType", {
                    initialValue: record.degreeType ? record.degreeType : null,
                  })(
                    <Select showSearch style={{ width: "100%" }}>
                      {condition
                        ? typeofDegree[record.qualification].map(
                          (val, index) => {
                            return (
                              <Option key={index} value={val.value}>
                                {val.value}
                              </Option>
                            );
                          }
                        )
                        : []}
                    </Select>
                  )}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Action",
        key: "operation",
        icon: "trash",
        fixed: "right",
        render: (val, record, key) => {
          return (
            <React.Fragment>
              <Tooltip title="Delete">
                <Button
                  shape="circle"
                  onClick={() => {
                    let tt = this.state.list;
                    tt = _.reject(tt, val);
                    this.setState({ list: tt });
                  }}
                  icon="delete"
                  size={"small"}
                />
              </Tooltip>
              {!record.editable && (
                <Tooltip title="Edit">
                  <Button
                    shape="circle"
                    style={{ marginLeft: "5px" }}
                    onClick={() => {
                      let newData = [...this.state.list];
                      newData = _.map(newData, (item) => {
                        item.editable = false;
                        return item;
                      });
                      newData[key] = { ...record, editable: true };
                      this.setState({ list: newData });
                    }}
                    icon="edit"
                    size={"small"}
                  />
                </Tooltip>
              )}

              {record.editable && (
                <a
                  style={{ color: "orange", marginLeft: "5px" }}
                  onClick={() => {
                    this.onSave(key);
                  }}
                >
                  Save
                </a>
              )}
            </React.Fragment>
          );
        },
      },
    ];

    const colum = [
      {
        title: "Country",
        key: "country",
        dataIndex: "country",
        render: (item) => {
          return item.countryName;
        },
      },
      {
        title: "City",
        key: "city",
        dataIndex: "city",
        render: (item) => {
          return item && item.cityName != null ? item.cityName : "";
        },
      },
      {
        title: "Action",
        key: "operation",

        render: (val, record) => (
          <a
            onClick={() => {
              let tt = this.state.totalPreference;
              tt = _.reject(tt, val);
              this.setState({ totalPreference: tt });
            }}
          >
            Remove
          </a>
        ),
      },
    ];

    const data = [
      {
        standard: "XII",
        degree: "Bachleor Of Engineering",
        year: "2012",
        maths: "NA",
        english: "NA",
        backlog: "2",
        major: "DS,CS",
        stream: "NA",
      },
    ];

    const columns = [
      { title: "Standard", dataIndex: "standard", key: "standard" },
      { title: "Degree", dataIndex: "degree", key: "degree" },
      { title: "Year", dataIndex: "year", key: "year" },
      { title: "Maths", dataIndex: "maths", key: "maths" },
      { title: "English", dataIndex: "english", key: "english" },
      { title: "Backlog", dataIndex: "backlog", key: "backlog" },
      { title: "Major ", dataIndex: "major", key: "major" },
      { title: "Stream ", dataIndex: "stream", key: "stream" },
    ];

    const steps = [
      {
        title: "Basic Info",
        content: "First-content",
      },
      {
        title: "Abroad Information",
        content: "Second-content",
      },
      {
        title: "Preferences",
        content: "Last-content",
      },
      {
        title: "Qualification/Jobs",
        content: "Last-content",
      },
    ];
    const refColumns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Mobile",
        dataIndex: "mobile",
        key: "mobile",
      },
      {
        title: "Country",
        dataIndex: "country",
        key: "country",
        render: (item) => {
          return item.countryName;
        },
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 150,
        render: (item, record) => (
          <React.Fragment>
            <a
              onClick={() => {
                let tt = this.state.totalData;
                tt = _.reject(tt, item);
                this.setState({ totalData: tt });
              }}
            >
              Remove
            </a>
            {/*<Tooltip title="Remove Reference">*/}
            {/*<Button*/}
            {/*type="danger"*/}
            {/*shape="circle"*/}
            {/*onClick={() => {*/}
            {/*this.removeRef(item)*/}
            {/*}}*/}
            {/*icon="delete"*/}
            {/*/>*/}
            {/*</Tooltip>*/}
          </React.Fragment>
        ),
      },
    ];


    const referFriendColumns = [
      {
        title: 'Student Name',
        key: 'referenceStudentName',
        dataIndex: 'referenceStudentName'
      },
      {
        title: 'Country Code',
        key: 'referenceCountryCode',
        dataIndex: 'referenceCountryCode'
      },
      {
        title: 'Mobile Number',
        key: 'referenceMobile',
        dataIndex: 'referenceMobile'
      },
      {
        title: 'Interested In',
        key: 'referenceInterestedIn',
        dataIndex: 'referenceInterestedIn'
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record, index) => (
          <Tooltip title="Remove Student">
            <Button shape="circle" icon="delete" size="small" onClick={() => this.removeReferenceStudent(index)} />
          </Tooltip>
        )
      }
    ]

    const jobColumns = [
      {
        title: "Job Title",
        dataIndex: "jobTitle",
        key: "jobTitle",
      },
      {
        title: "Company",
        dataIndex: "company",
        key: "company",
      },
      {
        title: "Reference Contact",
        dataIndex: "contactPerson",
        key: "contactPerson",
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone",
      },
      {
        title: "From",
        dataIndex: "from",
        key: "from",
      },
      {
        title: "To",
        dataIndex: "to",
        key: "to",
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 150,
        render: (item, record) => (
          <React.Fragment>
            <a
              onClick={() => {
                let tt = this.state.totalData1;
                tt = _.reject(tt, item);
                this.setState({ totalData1: tt });
              }}
            >
              Remove
            </a>
            <a
              style={{ marginLeft: "6px" }}
              onClick={() => {
                let tt = this.state.totalData1;
                tt = _.reject(tt, item);

                this.setState({
                  to: record.to,
                  from: record.from,
                  phone: record.phone,
                  jobTitle: record.jobTitle,
                  company: record.company,
                  contactPerson: record.contactPerson,
                  totalData1: tt,
                });
              }}
            >
              Edit
            </a>
          </React.Fragment>
        ),
      },
    ];

    return (
      <PageHeaderWrapper title={"Add Lead"}>
        {/*  <Card>
                 <div layout="inline" style={{marginTop: 8}}>


                 <Row>
                 <Col span={3} className={style.ctr}>
                 <div className={style.label}> Standard</div>
                 <Select style={{width: 100}} onChange={(standard) => {
                 this.setState({standard, show: false})
                 }}>
                 <Option value={'X'}>X</Option>
                 <Option value={'XII'}>XII</Option>
                 <Option value={'Diploma'}>Diploma</Option>
                 <Option value={'Graduation'}>Graduation</Option>
                 </Select>
                 </Col>
                 <Col span={3} className={style.ctr}>
                 <div className={style.label}> Degree</div>
                 <Select style={{width: 100}} onChange={(degree) => {
                 this.setState({degree})
                 }}>
                 <Option value={'Bachelor Of Engineering'}>Bachelor Of Engineering</Option>

                 </Select>
                 </Col>

                 <Col span={2} className={style.ctr}>
                 <div className={style.label}> Year</div>
                 <Input/>
                 </Col>


                 {
                 this.state.show ?
                 <Col span={2} className={style.ctr}>
                 <div className={style.label}> Maths</div>
                 <Input/></Col> : ''}
                 {
                 this.state.show ?
                 <Col span={2} className={style.ctr}>
                 <div className={style.label}> English</div>
                 <Input/></Col> : ''}
                 <Col span={2} className={style.ctr}>
                 <div className={style.label}> Backlog</div>
                 <Input/></Col>
                 <Col span={3} className={style.ctr}>
                 <div className={style.label}> Major Subjects <Input/></div>
                 </Col>
                 {
                 this.state.show ? <Col span={3} className={style.ctr}>
                 <div className={style.label}> Stream</div>
                 <Select style={{width: 100}}>
                 <Option value={'Arts'}>Arts</Option>
                 <Option value={'Non Medical'}>Non Medical</Option>
                 <Option value={'Medical'}>Medical</Option>
                 <Option value={'Commerce'}>Commerce</Option>
                 </Select>
                 </Col>
                 : ''}
                 <Col col={2} style={{marginTop: 4}}>
                 <Button type="primary" size={'small'} htmlType="submit" style={{marginTop: 10}}
                 loading={this.props.loading}>
                 SAVE
                 </Button>
                 </Col>

                 </Row>

                 <Row>
                 <Col span={24}>
                 <Card style={{margin: 20}}>
                 <Table columns={columns} dataSource={data}/>

                 </Card>

                 </Col>
                 </Row>


                 </div>
                 </Card>*/}

        <Modal
          title="Duplicate Student !"
          visible={showModal}
          onOk={() => {
            this.setState({ showModal: false, duplicateMsg: null });
          }}
          onCancel={() => {
            this.setState({ showModal: false, duplicateMsg: null });
          }}
        >
          <p>{duplicateMsg}</p>
        </Modal>


        {this.state.showWebCam && (
          <Drawer
            title=""
            placement="right"
            closable={true}
            onClose={() => {
              this.setState({
                showWebCam: false,
              });
            }}
            visible={this.state.showWebCam}
            width={1000}
          >
            <div>
              <h2
                style={{
                  marginLeft: "11px",
                  marginTop: "13px",
                  color: "orange",
                }}
              >
                Upload Profile Pic
              </h2>

              <Card>
                <p
                  style={{
                    padding: "10px",
                    textAlign: "justify",
                    marginLeft: "4px",
                    marginRight: "50px",
                  }}
                >
                  <div className={style.camStyle}>
                    <Row className={style.camStyleFull}>
                      <Col span={7}>
                        <Webcam
                          audio={false}
                          height={100}
                          ref={this.setRef}
                          screenshotFormat="image/jpeg"
                          width={180}
                          videoConstraints={videoConstraints}
                        />
                      </Col>
                      <Col span={7}>
                        {this.state.imageSrc ? (
                          <img src={this.state.imageSrc} />
                        ) : null}
                      </Col>
                      <Col span={10} className={style.btnGroup1}>
                        {this.state.imageSrc ? (
                          <Button
                            onClick={() => this.setState({ imageSrc: null })}
                            type="default"
                          >
                            Remove Image
                          </Button>
                        ) : null}

                        <Button onClick={this.capture} type="primary">
                          Capture Image
                        </Button>

                        <Button
                          onClick={() =>
                            this.setState({
                              showWebCam: false,
                            })
                          }
                          type="default"
                        >
                          Done
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </p>
              </Card>
            </div>
          </Drawer>
        )}

        <Steps current={current}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>

        <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
          <Card bordered={true}>

            {this._renderFormPart(
              current,
              getFieldDecorator,
              inputSchma,
              referAFriendSchema,
              firstTabExtra,
              addressInputSchema,
              permanentAddressInputSchema,
              currentAddressInputSchema,
              passportInputSchema,
              nationalityInputSchema,
              backgroundInfoInputSchema,
              emergencyContactInputSchema,
              telecallerSchema,
              inputSchema2,
              inputSchema3,
              qualColumns,
              list,
              refColumns,
              jobColumns,
              referFriendColumns
            )}

            <Card
              className={style.cardsep}
              style={{ display: current === 2 ? "inherit" : "none" }}
            >
              <Row gutter={16}>
                <div>
                  <div className={"referenceItem"}>
                    <div>
                      <h4>Select Countries</h4>
                      <Select
                        placeholder="Select Country"
                        showSearch={true}
                        optionFilterProp="children"
                        value={
                          this.state.country
                            ? this.state.country._id
                            : undefined
                        }
                        onChange={(ei) => {
                          let singleCountry = _.find(
                            this.state.countryArr,
                            (item) => {
                              return item._id == ei;
                            }
                          );

                          if (singleCountry) {
                            this.loadCities(singleCountry._id);
                          }
                          this.setState({ country: singleCountry, city: null });
                        }}
                      >
                        {this.state.countryArr.map((val, index) => {
                          return (
                            <Option key={index} value={val._id}>
                              {val.countryName}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>
                    <div>
                      <h4>Select Cities</h4>

                      <Select
                        placeholder="Select City"
                        showSearch={true}
                        optionFilterProp="children"
                        value={
                          this.state.city ? this.state.city._id : undefined
                        }
                        onChange={(ei) => {
                          let singleCity = _.find(
                            this.state.cityArr,
                            (item) => {
                              return item._id == ei;
                            }
                          );
                          if (singleCity) {
                            this.loadCities(singleCity._id);
                          }
                          this.setState({ city: singleCity });
                        }}
                      >
                        {this.state.cityArr &&
                          this.state.cityArr.map((val, index) => {
                            return (
                              <Option key={index} value={val._id}>
                                {val.cityName}
                              </Option>
                            );
                          })}
                      </Select>
                    </div>

                    <div>
                      <Button
                        style={{
                          marginTop: 25,
                          marginBottom: 23,
                        }}
                        icon="plus"
                        size={"small"}
                        type="primary"
                        onClick={() => {
                          if (!this.state.country) {
                            return notification.error({
                              message: "Choose Country",
                            });
                          }

                          if (this.state.country) {
                            let tt = this.state.totalPreference;
                            tt.push({
                              country: this.state.country,
                              city: this.state.city,
                            });
                            this.setState(
                              {
                                totalPreference: tt,
                                city: null,
                                country: null,
                              },
                              () => { }
                            );
                          }
                        }}
                      >
                        {/* ADD TO PREFERENCES */}
                      </Button>
                    </div>
                  </div>
                </div>
              </Row>
              <Row>
                <Col span={24}>
                  <Table
                    size={"small"}
                    pagination={{
                      defaultPageSize: 10,
                      showSizeChanger: false,
                      showQuickJumper: false,
                    }}
                    bordered={true}
                    columns={colum}
                    dataSource={this.state.totalPreference}
                  />
                </Col>
              </Row>
            </Card>

            <div className={style.stepsAction}>
              {current > 0 && (
                <Button
                  icon={"left-circle"}
                  size={"large"}
                  onClick={() => this.prev()}
                >
                  Previous
                </Button>
              )}

              {current < steps.length - 1 && (
                <Button
                  size={"large"}
                  style={{ marginTop: 10 }}
                  onClick={() => this.next()}
                >
                  Next
                  <Icon type="right-circle" />
                </Button>
              )}
              {current === steps.length - 1 && (
                <Button
                  size={"large"}
                  icon={"check-circle"}
                  type="primary"
                  loading={this.props.loading}
                  onClick={(e) => {
                    this.handleSubmit(e);
                  }}
                >
                  Done
                </Button>
              )}
            </div>
          </Card>
          {!!this.state.visible && (
            <Drawer
              title=""
              placement="right"
              closable={true}
              onClose={() => {
                this.setState({
                  visible: false,
                });
              }}
              visible={this.state.visible}
              width={1000}
            >
              <AddBranch
                formOnly={true}
                afterSave={() => {
                  this.loadAssociativePartners("Associate Partner");
                }}
              />
            </Drawer>
          )}
        </Form>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  allChannelPartners: global.allChannelPartners,
  search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddInquiry);
